import { PhraseTriggerMessageSource } from "@edgetier/watchtower-types";
import { PhraseSearchFormValues } from "./phrase-search.types";
import { EXACT_SIMILARITY_THRESHOLD } from "../../select-similarity/select-similarity.utilities";

export const EMPTY_FIELD_GROUP: PhraseSearchFormValues[] = [
    {
        sentence: "",
        source: [PhraseTriggerMessageSource.Customer],
        similarityThreshold: EXACT_SIMILARITY_THRESHOLD,
    },
];

export const CLEAR_OPEN_SEARCH_GROUP = {
    search: "",
    searches: undefined,
    textSearchType: undefined,
    similarityThreshold: undefined,
    searchType: undefined,
    parameterGroupId: undefined,
};
// Message sources that cannot take part in a similar search, so only an exact match is offered for them.
//
// `Bot` is a TEMPORARY entry (GAS-1074), not a product rule. The sentence vectoriser's SNS topic
// subscription filters bot messages out, so none are ever loaded into ClickHouse; the API then ignores a
// Bot-only source filter on a similar search and returns customer and agent messages instead. Rather than
// let the UI promise a search the backend silently substitutes, bot messages are restricted to exact
// search here. Remove `Bot` from this list once GAP-1833 ("Remove message source filtering join from
// similarity_search_olap") ships - `InteractionDetails` and `System` are excluded for a permanent
// structural reason and must stay.
export const EXACT_MESSAGE_SOURCES = [
    PhraseTriggerMessageSource.InteractionDetails,
    PhraseTriggerMessageSource.System,
    PhraseTriggerMessageSource.Bot,
];

// NON_EXACT_SIMILARITY_TYPES now lives in select-similarity.utilities, derived from SIMILARITY_ITEMS so a
// newly added option is picked up automatically. Re-exported here because this is where consumers of the
// phrase search look for it.
export { NON_EXACT_SIMILARITY_TYPES } from "../../select-similarity/select-similarity.utilities";
